import T from '../../services/language';
import styled from "styled-components";
import {Input, InputNumber, Select, TimePicker} from "antd";
import {useEffect, useRef, useState} from "react";
import moment, {Moment} from "moment";
import {hexToRgbA, singleClick} from "../../services/app";
import {useParams} from "react-router-dom";
import {getCalenderMonthStartAndEnd, getLocalDateId} from "./service";
import {Modal, ModalContent, ModalContentBody, ModalContentFooter, ModalContentHead} from "../Campaign/style";
import {useApp} from "../../contexts/app";
import {TextPlaceholder, usePlaceholderLoading} from "../../components/Loading/placeholder";
import Environment from "../../environment";

moment.updateLocale('en', {week: {dow: 1,}});

const CalendarContainer = styled.div`
    margin: 0px 0 12px 0;
    border: 1px solid #BEBEBE;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 24px;
`;
const CalendarTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F6F6F6;
    padding: 10px 12px;

    & > svg {
        height: 28px;
        width: 48px;
        cursor: pointer;
        border: 1px solid transparent;
        border-radius: 8px;
        transition: all 0.1s ease-in;

        &:hover {
            border-color: ${props => props.theme.main || "#40A68C"};
        }

        &:hover path {
            fill: ${props => props.theme.main || "#40A68C"};
        }
    }
`;
const CalendarTitle = styled.div`
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #494949;
    display: flex;
    align-items: center;
    text-transform: capitalize;

    & svg {
        margin-left: 4px;
    }
`;
const CalendarBody = styled.div`
    padding: 0 18px;
`;
const CalendarBodyRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 8px;
`;
const CalendarBodyRowItem = styled.div`
    width: 32px;
    height: 32px;
    font-weight: 500;
    font-size: 12px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    color: #494949;
    opacity: 0.5;
    border: 1px solid transparent;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition: all 0.1s ease-in;

    &:hover {
        opacity: 0.9;
        background-color: #F6F6F6;
    }

    &.current-month {
        opacity: 1;
    }

    &.today {
        border: 1px solid ${props => props.theme.main || "#40A68C"};
    }

    &.has-schedule {
        color: ${props => props.theme.main || "#40A68C"};
        background: ${props => hexToRgbA(props.theme.main || "#40A68C", 0.1)};
    }

    &.out-slot {
        color: #828282;
        background: #DDDDDD;
    }

    &.selected {
        color: #fff;
        background: ${props => props.theme.main || "#40A68C"};
    }

    &.out-slot.selected {
        border-color: #494949;
        color: #828282;
        background: #DDDDDD;
    }

    /* Not bookable — either outside the campaign/service window, or outside
       the [today + minDayToBook, today + maxDayToBook] range. Kept visually
       plain (no strikethrough, no colour change) — the *absence* of the
       blue highlight is enough to signal "not an option". Click is a no-op
       so the customer can't accidentally select a date that the server
       would reject on submit. */
    &.unavailable {
        cursor: default;
    }

    &.unavailable:hover {
        background-color: transparent;
    }
`;
const CalendarHead = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background: #F6F6F6;
    padding: 0 18px 6px 18px;
    margin-bottom: 8px;
    position: relative;

    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 18px;
        width: calc(100% - 36px);
        border-bottom: 1px solid #DDDDDD;
    }
`;
const CalendarHeadItem = styled.div`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 12px;
    color: #494949;

`;


export const dateRangeToArray = (from, to) => {
    const result = [];
    let start = from.toDate();
    let end = to.toDate();
    while (start < end) {
        result.push(moment(start));
        let newDate = start.setDate(start.getDate() + 1);
        start = new Date(newDate);
    }
    return result
}

export const checkOutSlot = (schedule, getAllBooking, packageIndex, schedules) => {
    let totalSlot = 0;
    const currentSchedule = (schedules || []).find(item =>
        item?.scheduleId === schedule?.scheduleId &&
        item?.startDate === schedule?.startDate &&
        item?.value?.fromTimeText === schedule?.value?.fromTimeText
    ) || schedule;
    const allBooking = getAllBooking();
    (allBooking || []).filter((item, index) => index !== packageIndex).map(item => {
        if (
            item?.schedule?.scheduleId === schedule?.scheduleId &&
            item?.schedule?.startDate === schedule?.startDate &&
            item?.schedule?.value?.fromTimeText === schedule?.value?.fromTimeText
        ) {
            totalSlot += 1;
        }
    });
    const paxAvaiable = (currentSchedule && (typeof currentSchedule?.paxAvaiable === 'number') ? (currentSchedule?.paxAvaiable || 0) : schedule?.paxAvaiable);
    return totalSlot >= (paxAvaiable || 0)
}

export const checkRegion = (schedule, postalCode) => {
    const firstPostalCode = (postalCode || "")?.toString().substring(0, 2);
    if (schedule.isOnsite && schedule?.regions?.length > 0 && !schedule?.regions.find(item => item.postalCodes?.includes(firstPostalCode))) {
        return false;
    }
    return true
}

export const checkLimitDayBooking = (campaign, dateCheck, timeCheck) => {
    const currentDate = moment();
    let dateToCheck = moment(`${timeCheck} ${dateCheck}`, `${Environment.timeFormat} ${Environment.dateFormat}`);
    dateToCheck = dateToCheck.isValid() ? dateToCheck : moment();
    // 2026-05-08 — minDate anchors at start-of-day, not the current minute.
    // Previously `currentDate.clone().add(minDayToBook, 'days')` carried the
    // current time-of-day forward, so when minDayToBook=0 ("today is OK") any
    // slot starting before "right now" got filtered out — admin sets up a 9am
    // slot, opens the booking page at 9:30am, the 9am slot disappears even
    // though it hasn't started yet. minDayToBook is a DAY count by contract
    // (matches isDateBookableByDayLimit below); time-of-day belongs in a
    // separate "is this slot in the past" check, which we don't need here
    // because the schedule list itself filters out past slots upstream.
    // maxDate kept at minute granularity because that's the existing contract
    // and there's no equivalent UX bug at the upper bound.
    const maxDate = currentDate.clone().add(campaign?.maxDayToBook || 99999, 'days');
    const minDate = currentDate.clone().startOf('day').add(campaign?.minDayToBook || 0, 'days');
    return dateToCheck.isBetween(minDate, maxDate, null, '[]');
}

/**
 * Date-level bookability check — used to grey out calendar cells instead of
 * letting the customer click a date only to be blocked on submit.
 *
 * A date is bookable when it's:
 *   - within [today + minDayToBook, today + maxDayToBook] (day granularity)
 *   - within the campaign/service active window (checkIsInCampaignAndServiceDateRange)
 *
 * Note: `checkLimitDayBooking` above mixes in a time-of-day comparison; for
 * day-level calendar filtering we need day granularity, hence this separate
 * helper.
 */
export const isDateBookableByDayLimit = (campaign: any, dateMoment: Moment): boolean => {
    if (!dateMoment || !dateMoment.isValid()) return false;
    const today = moment().startOf('day');
    const minDate = today.clone().add(campaign?.minDayToBook || 0, 'days');
    const maxDate = today.clone().add(campaign?.maxDayToBook || 99999, 'days');
    const target = dateMoment.clone().startOf('day');
    return !target.isBefore(minDate, 'day') && !target.isAfter(maxDate, 'day');
};

export const checkIsInCampaignAndServiceDateRange = (item: { campaign: any, service: any }, dateCheck: Moment) => {
    const {campaign, service} = item;
    if (!campaign) return true;
    const minDateCampaign = moment(campaign?.startDate, Environment.dateFormat).startOf('date');
    const maxDateCampaign = moment(campaign?.endDate, Environment.dateFormat).endOf('date');
    let minDate = minDateCampaign.clone()
    let maxDate = maxDateCampaign.clone()

    if (
        service?.campaignPssGroup?.startDate && moment(service?.campaignPssGroup?.startDate).isValid() &&
        service?.campaignPssGroup?.endDate && moment(service?.campaignPssGroup?.endDate).isValid()
    ) {
        const minDateService = moment(service?.campaignPssGroup?.startDate).startOf('date');
        const maxDateService = moment(service?.campaignPssGroup?.endDate).endOf('date');
        // Calc minDate & maxDate is sub range
        minDate = moment.max(minDateCampaign, minDateService);
        maxDate = moment.min(maxDateCampaign, maxDateService);

    }
    return dateCheck.clone().toDate().getTime() >= minDate.toDate().getTime() && dateCheck.clone().toDate().getTime() <= maxDate.toDate().getTime();
}

export const Calendar = (props: any) => {
    const value = props.value || "";
    const onChange = props.onChange;
    const format = Environment.dateFormat;
    const date = value ? moment(value, format) : moment(Date.now());
    const daysOfWeek = Array.from({length: 7}, (_, i) => moment().weekday(i).format('ddd'));
    const schedules = props.schedules;
    const isOnsite = props.isOnsite;
    const packageIndex = props.packageIndex;
    const [modal, setModal] = useState(false);
    const resultCalenderMonthStartAndEnd = getCalenderMonthStartAndEnd(date);
    const firstDay = resultCalenderMonthStartAndEnd.startMonth;
    const lastDay = resultCalenderMonthStartAndEnd.endMonth;
    const {getAllBooking, campaign, getLocalProductService} = useApp();
    let {postalCode, productServiceId} = useParams();
    const {setLoading, loading} = usePlaceholderLoading();
    const service = getLocalProductService(productServiceId);

    const onSubmit = (item) => {
        item ? onChange(item.format(format)) : onChange("");
    }

    const onMonth = (step) => {
        singleClick(() => {
            setLoading(true);
            onSubmit(date.clone().add(step, 'month'))
        })
    }

    const dates = dateRangeToArray(firstDay, lastDay);

    return (
        <CalendarContainer>
            <CalendarTop>
                <LeftIcon onClick={() => onMonth(-1)}/>
                <CalendarTitle onClick={() => setModal(true)}>
                    {date.format("MMMM, YYYY")}
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.5 14.6665H2.5C2.22667 14.6665 2 14.4398 2 14.1665C2 13.8932 2.22667 13.6665 2.5 13.6665H14.5C14.7733 13.6665 15 13.8932 15 14.1665C15 14.4398 14.7733 14.6665 14.5 14.6665Z"
                            fill="#828282"/>
                        <path
                            d="M13.1799 2.31994C11.8866 1.02661 10.6199 0.993275 9.29322 2.31994L8.48655 3.12661C8.41989 3.19328 8.39322 3.29994 8.41989 3.39328C8.92655 5.15994 10.3399 6.57328 12.1066 7.07994C12.1332 7.08661 12.1599 7.09328 12.1866 7.09328C12.2599 7.09328 12.3266 7.06661 12.3799 7.01328L13.1799 6.20661C13.8399 5.55328 14.1599 4.91994 14.1599 4.27994C14.1666 3.61994 13.8466 2.97994 13.1799 2.31994Z"
                            fill="#828282"/>
                        <path
                            d="M10.9066 7.68654C10.7132 7.5932 10.5266 7.49987 10.3466 7.3932C10.1999 7.30654 10.0599 7.2132 9.91989 7.1132C9.80655 7.03987 9.67322 6.9332 9.54655 6.82654C9.53322 6.81987 9.48655 6.77987 9.43322 6.72654C9.21322 6.53987 8.96655 6.29987 8.74655 6.0332C8.72655 6.01987 8.69322 5.9732 8.64655 5.9132C8.57989 5.8332 8.46655 5.69987 8.36655 5.54654C8.28655 5.44654 8.19322 5.29987 8.10655 5.1532C7.99989 4.9732 7.90655 4.7932 7.81322 4.60654C7.69085 4.34431 7.34668 4.26641 7.14206 4.47103L3.39322 8.21987C3.30655 8.30654 3.22655 8.4732 3.20655 8.58654L2.84655 11.1399C2.77989 11.5932 2.90655 12.0199 3.18655 12.3065C3.42655 12.5399 3.75989 12.6665 4.11989 12.6665C4.19989 12.6665 4.27989 12.6599 4.35989 12.6465L6.91989 12.2865C7.03989 12.2665 7.20655 12.1865 7.28655 12.0999L11.0416 8.34484C11.2421 8.14432 11.1668 7.79929 10.9066 7.68654Z"
                            fill="#828282"/>
                    </svg>
                </CalendarTitle>
                <RightIcon onClick={() => onMonth(1)}/>
            </CalendarTop>
            <CalendarHead>
                {daysOfWeek.map((item, index) => (<CalendarHeadItem key={index.toString()}>{item}</CalendarHeadItem>))}
            </CalendarHead>
            <CalendarBody>
                {
                    [1, 2, 3, 4, 5, 6].map((x, i) => {
                        // Remove row 5 if current month has 5 rows and total dates less than 36
                        if (i === 5 && dates.length <= 36) return null;
                        return (
                            <CalendarBodyRow key={i.toString()}>
                                {
                                    daysOfWeek.map((x2, i2) => {
                                        const index = (i * 7 + i2);
                                        const item = dates[index];
                                        if (!item) return null;
                                        const items = schedules.filter(x => x.startDate === item.format(item.format(Environment.dateFormat)));
                                        const isActive = (date || moment()).format(Environment.dateFormat) === item.format(Environment.dateFormat);
                                        const isHasSchedule = !!items.filter(x => !checkOutSlot(x, getAllBooking, packageIndex, schedules)
                                            && checkRegion({...x, isOnsite}, postalCode)
                                            && checkLimitDayBooking(campaign, item.format(Environment.dateFormat), x?.value?.fromTimeText)
                                        )?.length;
                                        const inCampaignRange = checkIsInCampaignAndServiceDateRange({
                                            campaign,
                                            service
                                        }, item)
                                        const isOutSlot = items?.length && !items.filter(x => !checkOutSlot(x, getAllBooking, packageIndex, schedules))?.length;

                                        // check all item in current date is out slot show slot
                                        const canShowItems = items.filter(x => checkRegion({
                                                    ...x,
                                                    isOnsite
                                                }, postalCode)
                                                && checkLimitDayBooking(campaign, item.format(Environment.dateFormat), x?.value?.fromTimeText)
                                        );
                                        const isAllCurrentOutSlot = !canShowItems.filter(x => !checkOutSlot(x, getAllBooking, packageIndex, schedules)).length && !!canShowItems?.length;

                                        // Grey out dates the backend would reject on submit:
                                        // outside campaign/service window, or outside the
                                        // minDayToBook/maxDayToBook window. Previously these
                                        // stayed clickable and the customer only found out on
                                        // the Next button click — bad UX per team feedback.
                                        const isWithinDayLimit = isDateBookableByDayLimit(campaign, item);
                                        const isUnavailable = !inCampaignRange || !isWithinDayLimit;

                                        return item ? (
                                            <CalendarBodyRowItem
                                                onClick={() => {
                                                    if (isUnavailable) return;
                                                    onSubmit(item);
                                                    console.log("click:", items);
                                                    console.log("click canShowItems:", canShowItems);
                                                }}
                                                className={!loading && `
                                                    day-${item.day()}
                                                    ${isActive && !isUnavailable ? "selected" : ""}
                                                    ${isUnavailable ? "unavailable" : ""}
                                                    ${!isUnavailable && (isOutSlot || isAllCurrentOutSlot) ? "out-slot" : ""}
                                                    ${!isUnavailable && isHasSchedule && inCampaignRange ? "has-schedule" : ""}
                                                    ${getLocalDateId(moment(Date.now())) === getLocalDateId(item) ? "today" : ""}
                                                    ${date.clone().format('MM') === item.format("MM") ? "current-month" : ""}
                                                `.split("\n").join(" ").trim()}
                                                key={index.toString()}>
                                                <TextPlaceholder lines={[1]} itemStyle={{
                                                    marginBottom: 0,
                                                    height: 30,
                                                    width: 30,
                                                    borderRadius: 15
                                                }}>{item.format("D")}</TextPlaceholder>
                                            </CalendarBodyRowItem>
                                        ) : null
                                    })
                                }
                            </CalendarBodyRow>
                        )
                    })
                }
            </CalendarBody>
            {modal ? <MonthYearSelect onClose={(event) => {
                setModal(false);
            }} value={date} onChange={(event) => {
                onSubmit(event.clone());
                setModal(false);
            }}/> : null}
        </CalendarContainer>
    )
}

const ChooseTimeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    & > div:nth-child(n+5) {
        margin-right: 0;
    }
`;
export const ChooseTimeItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 50px;
    border: 1px solid #BEBEBE;
    border-radius: 8px;
    width: calc(20% - 8px);
    backdrop-filter: blur(2px);
    margin-right: 10px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #727C8A;
    margin-bottom: 10px;
    transition: all 0.3s ease-in;

    &.active {
        background: ${props => props.theme.main || "#1D896D"};
        border-color: ${props => props.theme.main || "#1D896D"};
        border-radius: 8px;
        color: white;
    }
`;
export const ChooseTime = (props: any) => {
    const format = Environment.dateFormat;
    const date = props.date ? moment(props.date, format) : moment(Date.now());
    const value = props.value || "";
    const placeholder = props.placeholder || "";
    const schedules = props.schedules;
    const onChange = props.onChange;
    const {getAllBooking, campaign, getLocalProductService} = useApp();
    const scheduleId = props.scheduleId;
    const packageIndex = props.packageIndex;
    const isOnsite = props.isOnsite;
    let {postalCode, productServiceId} = useParams();
    const service = getLocalProductService(productServiceId);

    const onSubmit = (item) => {
        onChange({
            schedule: item,
            startTime: item?.value?.fromTimeText,
            endTime: item?.value?.toTimeText,
        });
    }
    let dayItems = schedules.filter(x => x.startDate === date.format(format));
    // if selected day out of range camp date then clear all schedule
    if (!checkIsInCampaignAndServiceDateRange({campaign, service}, date)) {
        dayItems = [];
    }

    const items = dayItems.filter(x =>
        checkRegion({...x, isOnsite}, postalCode)
        && checkLimitDayBooking(campaign, date.format(format), x?.value?.fromTimeText)
    )
        .sort((a, b) => {
            const numberA = parseInt((a?.value?.fromTimeText || "").replace(":", ""));
            const numberB = parseInt((b?.value?.fromTimeText || "").replace(":", ""));
            if (numberA === numberB) {
                const numberC = parseInt((a?.value?.toTimeText || "").replace(":", ""));
                const numberD = parseInt((b?.value?.toTimeText || "").replace(":", ""));
                return numberC > numberD ? 1 : (numberC < numberD ? -1 : 0)
            }
            return numberA > numberB ? 1 : (numberA < numberB ? -1 : 0)
        });

    const valueSelect = ((scheduleId || "") + value).trim() || undefined;
    const isAllOutSlot = !!dayItems?.length && !dayItems.filter(x => !checkOutSlot(x, getAllBooking, packageIndex, schedules))?.length
    const isAllCurrentOutSlot = !!items?.length && !items.filter(x => !checkOutSlot(x, getAllBooking, packageIndex, schedules))?.length

    return (
        <TextPlaceholder itemStyle={{height: 50, borderRadius: 8}} lines={[1]}>
            {
                (items?.length === 0 || !!isAllOutSlot || !!isAllCurrentOutSlot) ? (
                    <ChooseTimeItem style={{width: '100%'}}>
                        {isAllOutSlot || isAllCurrentOutSlot ? T("Fully booked") : T("No schedule")}
                    </ChooseTimeItem>
                ) : (
                    <SelectView placeholder={placeholder} value={valueSelect}
                                onChange={(value: any, option: any) => {
                                    onSubmit(items[parseInt(option.key)])
                                }}>
                        {
                            items.map((item, index) => {
                                const isOutSlot = checkOutSlot(item, getAllBooking, packageIndex, schedules);
                                return (
                                    <SelectView.Option disabled={isOutSlot} key={index.toString()}
                                                       value={(item?.sid || "") + item?.value?.fromTimeText}>
                                        <span className={`${isOutSlot ? 'option-outslot' : ''}`}>
                                            {T("{startTime} to {endTime}", {
                                                startTime: item?.value?.fromTimeText2,
                                                endTime: item?.value?.toTimeText2
                                            })}
                                        </span>

                                    </SelectView.Option>
                                )
                            })
                        }
                    </SelectView>
                )
            }
        </TextPlaceholder>

    )
}

export const Control = styled.div`
    flex: 1;
    margin-bottom: 18px;
`;
export const ControlRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
export const LabelView = styled(TextPlaceholder).attrs({
    lines: [1],
    itemStyle: {height: 20, width: 150, marginLeft: 0}
})`
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #494949;
    margin-bottom: 10px;
    margin-top: 12px;
`;
export const TextView = styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #494949;
    min-height: 20px;
`;
export const LabelView2 = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #5D5D5D;
    margin-bottom: 10px;
`;
export const LabelViewSub = styled.div`
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #626262;
    margin-bottom: 6px;

    &.text {
        color: ${props => props.theme.main || "#1D896D"};
    }
`;
export const InputView = styled(Input)`
    height: 50px;
    background: #FFFFFF;
    border: 1px solid #BEBEBE;
    border-radius: 10px;
    padding: 12px 16px;
`;
export const InputNumberView = styled(InputNumber)`
    height: 50px;
    background: #FFFFFF;
    border: 1px solid #BEBEBE;
    border-radius: 10px;
    width: 100%;

    & input {
        padding: 12px 16px;
        height: 48px;
        line-height: 48px;
    }

    & .ant-input-number-handler-wrap {
        display: none;
    }
`;
export const TextAreaView = styled(Input.TextArea)`
    background: #FFFFFF;
    border: 1px solid #BEBEBE;
    border-radius: 10px;
    padding: 12px 16px;
`;
export const SelectView = styled(Select).attrs(props => ({
    suffixIcon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.9465 5.45312H7.79316H4.05317C3.41317 5.45312 3.09317 6.22646 3.5465 6.67979L6.99983 10.1331C7.55317 10.6865 8.45317 10.6865 9.0065 10.1331L10.3198 8.81979L12.4598 6.67979C12.9065 6.22646 12.5865 5.45312 11.9465 5.45312Z"
                fill="#626262"/>
        </svg>
    ),
}))`
    width: 100%;

    & .ant-select-selector {
        height: 50px !important;
        background: #FFFFFF !important;
        border: 1px solid #BEBEBE !important;
        border-radius: 8px !important;
    }

    & .ant-select-selection-item {
        font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 48px !important;
        color: #2A2F36 !important;
    }

    & .ant-select-selection-search-input, & .ant-select-selection-placeholder {
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 48px !important;
        height: 48px !important;
    }
`;

export const ControlTimeRange = styled(TimePicker.RangePicker).attrs((props: any) => {
    return {
        inputReadOnly: true,
        allowClear: false,
        placeholder: ["00:00", "00:00"],
        popupClassName: 'custom-picker',
        value: props.fromTime && props.toTime ? [moment(props.fromTime, "HH:mm"), moment(props.toTime, "HH:mm")] : undefined,
        onBlur: (event) => {
            const items = event.target.parentElement.parentElement.querySelectorAll('input');
            props.onChange([moment(items[0].value || items[1].value, "HH:mm"), moment(items[1].value || items[0].value, "HH:mm")]);
        }
    }
})`
    &.ant-picker-range {
        border: none;
        border-bottom: 1px solid #BEBEBE;
        box-shadow: none !important;
        padding: 0px;
        height: 22px;
        width: 100px;
        margin-right: 6px;
    }

    & .ant-picker-suffix {
        display: none;
    }

    &.ant-picker-range .ant-picker-active-bar {
        bottom: -1px;
        height: 1px;
        left: 0 !important;
        width: 100% !important;
        margin-left: 0px !important;
    }

    & .ant-picker-separator svg {
        display: none;
    }

    & .ant-picker-range-separator {
        padding: 0;
    }

    & .ant-picker-input > input {
        font-weight: 500 !important;
        font-size: 14px;
        line-height: 20px !important;
        color: #494949 !important;
        text-align: center !important;
    }

    & .ant-picker-separator:after {
        content: "-";
        color: black;
        width: 16px;
        height: 16px;
        text-align: center;
        display: block;
        position: absolute;
        top: 0;
        line-height: 16px;
    }
`;

const LeftIcon = (props: any) => (
    <svg {...props} width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="28" rx="8" fill="white"/>
        <path
            d="M25.9587 20C25.694 20 25.4294 19.9018 25.2204 19.6915L20.303 14.7415C19.899 14.3348 19.899 13.6617 20.303 13.255L25.2204 8.305C25.6244 7.89833 26.293 7.89833 26.697 8.305C27.101 8.71166 27.101 9.38475 26.697 9.79141L22.5179 13.9982L26.697 18.2051C27.101 18.6117 27.101 19.2848 26.697 19.6915C26.502 19.9018 26.2373 20 25.9587 20Z"
            fill="#727C8A"/>
    </svg>
)
const RightIcon = (props: any) => (
    <svg {...props} width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="28" rx="8" transform="matrix(-1 0 0 1 48 0)" fill="white"/>
        <path
            d="M22.0413 20C22.306 20 22.5706 19.9018 22.7796 19.6915L27.697 14.7415C28.101 14.3348 28.101 13.6617 27.697 13.255L22.7796 8.305C22.3756 7.89833 21.707 7.89833 21.303 8.305C20.899 8.71166 20.899 9.38475 21.303 9.79141L25.4821 13.9982L21.303 18.2051C20.899 18.6117 20.899 19.2848 21.303 19.6915C21.498 19.9018 21.7627 20 22.0413 20Z"
            fill="#727C8A"/>
    </svg>

)

const ListSelect = styled.div`
    width: 100%;
    height: 145px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    flex: 1;

    &::-webkit-scrollbar {
        display: none;
    }
`;
const ListSelectItem = styled.div`
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    line-height: 29px;
    color: #989898;
    height: 29px;

    &.active {
        color: #494949;
    }
`;

const Reset = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px 16px;
    width: 139px;
    height: 48px;
    background: #E9EEF6;
    border-radius: 50px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #494949;
`;
const Apply = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px 16px;
    width: 139px;
    height: 48px;
    background: ${props => props.theme.main || "#1D896D"};
    border-radius: 50px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #FFFFFF;

`;
const ListSelectView = (props: any) => {
    const items = props.items;
    const value = props.value;
    const onChange = props.onChange;
    const containerRef = useRef(null);
    const [middleIndex, setMiddleIndex] = useState(items?.findIndex(x => x === value) >= 0 ? items?.findIndex(x => x === value) : 0);

    useEffect(() => {
        if (value) {
            const index = items?.findIndex(x => x === value) >= 0 ? items?.findIndex(x => x === value) : 0;
            if (index >= 0 && index !== middleIndex) {
                setMiddleIndex(index);
                containerRef?.current?.querySelector(`.key-${index + 2}`)?.scrollIntoView({
                    block: "center"
                });
            }
        }
    }, [value])

    useEffect(() => {
        if (middleIndex >= 0 && !!onChange && items[middleIndex]) {
            onChange(items[middleIndex]);
        }
    }, [middleIndex])

    useEffect(() => {
        const container = containerRef.current;
        const children = container.children;
        const containerHeight = 145;
        const itemHeight = 29;

        const checkMiddlePoint = () => {
            if (!containerRef.current.disabled) {
                const middlePoint = container.scrollTop + (containerHeight / 2);
                const index = Math.floor(middlePoint / itemHeight);
                setMiddleIndex(index - 2);
                scrollToIndex(index, true);
            }
        };

        container.addEventListener('scroll', checkMiddlePoint);


        containerRef?.current?.querySelector(`.key-${middleIndex + 2}`)?.scrollIntoView({
            block: "center"
        });
        return () => {
            container.removeEventListener('scroll', checkMiddlePoint);
        };
    }, []);

    const scrollToIndex = (index, delay = false) => {
        if (containerRef.current.timer) {
            clearTimeout(containerRef.current.timer);
        }
        if (delay) {
            containerRef.current.timer = setTimeout(() => {
                containerRef.current.querySelector(`.key-${index}`).scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                setTimeout(() => {
                    containerRef.current.disabled = false;
                }, 200)
            }, 300);
        } else {
            containerRef.current.disabled = true;
            containerRef.current.querySelector(`.key-${index}`).scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            setTimeout(() => {
                containerRef.current.disabled = false;
            }, 200)
        }
    }

    return (
        <ListSelect ref={containerRef}>
            {
                ["", "", ...items, "", ""].map((value, index) => {
                    return (
                        <ListSelectItem onClick={() => {
                            if (!!items[index - 2]) {
                                setMiddleIndex(index - 2);
                                scrollToIndex(index);
                            }
                        }} className={`key-${index} ${middleIndex === index - 2 ? 'active' : ""}`}
                                        key={index.toString()}>{value}</ListSelectItem>
                    )
                })
            }
        </ListSelect>
    )
}

export const MonthYearSelect = (props: any) => {
    const value = props.value;
    const [date, setDate] = useState(value ? value?.clone() : moment(Date.now()))

    const years = [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050, 2051, 2052, 2053, 2054, 2055, 2056, 2057, 2058, 2059, 2060, 2061, 2062, 2063, 2064, 2065, 2066, 2067, 2068, 2069, 2070, 2071, 2072, 2073, 2074, 2075, 2076, 2077, 2078, 2079, 2080, 2081, 2082, 2083, 2084, 2085, 2086, 2087, 2088, 2089, 2090, 2091, 2092, 2093, 2094, 2095, 2096, 2097, 2098, 2099, 2100];
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(x => moment(x, "M").format("MMMM"));

    return (
        <Modal>
            <ModalContent style={{maxWidth: 350}}>
                <ModalContentHead style={{height: "auto"}}>
                    <svg onClick={props.onClose} width="24" height="24" viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3165 18.7071 18.7071C18.3165 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                              fill="#626262"/>
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70705 18.7071C6.31652 19.0977 5.68336 19.0977 5.29283 18.7071C4.90231 18.3166 4.90231 17.6835 5.29283 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
                              fill="#626262"/>
                    </svg>
                </ModalContentHead>
                <ModalContentBody style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flex: 1,
                    width: '100%',
                    marginBottom: 24
                }}>
                    <ListSelectView onChange={(event) => {
                        setDate(date.clone().set("months", event))
                    }} value={date.format("MMMM")} items={months}/>
                    <ListSelectView onChange={(event) => {
                        setDate(date.clone().set("years", event))
                    }} value={parseInt(date.format("YYYY"))} items={years}/>
                </ModalContentBody>
                <ModalContentFooter>
                    <Reset style={{marginRight: 6}} onClick={() => {
                        const resetDate = date.clone();
                        resetDate.set('months', moment(Date.now()).get('months'));
                        resetDate.set('years', moment(Date.now()).get('years'));
                        setDate(resetDate);
                    }}>{T('Reset')}</Reset>
                    <Apply onClick={() => props.onChange(date)}>{T('Apply')}</Apply>
                </ModalContentFooter>
            </ModalContent>
        </Modal>
    )
}

export const ErrorMessage = styled.div`
    font-size: 12px;
    font-weight: 400;
    color: red;
    margin-bottom: 24px;
    margin-top: -20px;
`;